// Curated video walkthroughs
export const videoShowcase = [
    {
        videoId: "xjFeKB6rWfw",
        title: "Sunburn Project",
        subtitle: "Project Showcase Nº 01",
    },
    {
        videoId: "ETAFXBo5Y8I",
        title: "TOT Club",
        subtitle: "Project Showcase Nº 02",
    },
    {
        videoId: "7Stk0ayFPo0",
        title: "Editorial Residence Walkthrough",
        subtitle: "Project Showcase Nº 03",
    },
    {
        videoId: "PKGNav61uNY",
        title: "Signature Living Spaces",
        subtitle: "Project Showcase Nº 04",
    },
    {
        videoId: "o8EPhVl-GpA",
        title: "Bespoke Interior Story",
        subtitle: "Project Showcase Nº 05",
    },
    {
        videoId: "e4T3cY1FjAM",
        title: "Crafted Home Narrative",
        subtitle: "Project Showcase Nº 06",
    },
];
